import { useEffect, useState } from "react"

import { useQueryParam } from "web/hooks/context"
import { distinctBy } from "web/services/helpers"

import { getMapBoxSafeValues } from "./common"

import LocationMap from "./LocationMap"
import AssetLocationCard from "./LocationCard/AssetLocationCard"

export default function AssetMap({
  assets,
  onSelectionChanged,
  onItemClick,
  isLoading,
  showOrdinals,
}) {
  const [locationInFocus, setLocationInFocus] = useState()
  const hasLocationInFocus = !!locationInFocus

  const assetLocations = assets.map((asset) => {
    const assetValues = getMapBoxSafeValues(asset.values)
    return { ...asset.locations[0], asset_id: asset.id, values: assetValues }
  })

  const distinctAssetLocations = distinctBy(assetLocations, "id")

  const locationInFocusWithSubjects = { location: locationInFocus }

  if (hasLocationInFocus) {
    const assetsAtLocation = assets.filter((a) =>
      a.locations.some((l) => l.id === locationInFocus.id)
    )

    const assetDealIdsAtLocation = assetsAtLocation
      .map((a) => a.account_deals)
      .flat()
      .map((ad) => ad.deal_id)

    const assetSaleIdsAtLocation = assetsAtLocation
      .map((a) => a.sale_ids)
      .flat()

    locationInFocusWithSubjects.assets = assetsAtLocation
    locationInFocusWithSubjects.dealIds = assetDealIdsAtLocation
    locationInFocusWithSubjects.saleIds = assetSaleIdsAtLocation
  }

  const primarySubject =
    hasLocationInFocus && locationInFocusWithSubjects.assets[0]

  const hasPrimarySubject = !!primarySubject

  // asset in focus may have been removed between
  // renders by change in filter conditions
  useEffect(() => {
    if (hasLocationInFocus && !hasPrimarySubject) {
      setLocationInFocus(undefined)
    }
  }, [hasLocationInFocus, hasPrimarySubject])

  const selected = assets.filter((el) => el.selected)

  const center_on = useQueryParam("center_on")
  const shouldCenterMap = !!center_on && !locationInFocus

  const centralLocation =
    // eslint-disable-next-line eqeqeq
    shouldCenterMap && assetLocations.find((l) => l.asset_id == center_on)

  return (
    <LocationMap
      subjectType="asset"
      subjects={assets}
      primarySubject={primarySubject}
      selected={selected}
      locations={distinctAssetLocations}
      locationInFocus={locationInFocusWithSubjects}
      centralLocation={centralLocation}
      onLocationClick={setLocationInFocus}
      onSelectionChanged={onSelectionChanged}
      onItemClick={onItemClick}
      detailCard={AssetLocationCard}
      isLoading={isLoading}
      showOrdinals={showOrdinals}
    />
  )
}
